import { combineReducers } from 'redux';
import { Actions, ActionTypes } from './actions';
import { IOverlayClass } from './Overlay';

export const overlays = (state = [] as IOverlayClass[], action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.PUSH_OVERLAY:
			return [...state, action.payload.overlay];
		case ActionTypes.POP_OVERLAY:
			// NOTE: popping an overlay should pop any overlays that have been
			// added on top of it. However, in general use there should only ever
			// be one overlay- this is just a sanity clause and not a feature that
			// you should depend on.
			// This overlay mechanism also assumes that there is only ever one
			// overlay of each Overlay class.
			return state.slice(0, state.indexOf(action.payload.overlay));
		default:
			return state;
	}
};

export interface IOverlayState {
	overlays: ReturnType<typeof overlays>;
}

const ui = combineReducers<IOverlayState>({
	overlays
});

export default ui;
